const BLOCK_BOT_NAME = 'Jibri';

export {
  BLOCK_BOT_NAME
};
